import { Box, Typography } from '@mui/material';
import React, { useContext, useEffect } from 'react';
import Header from '../components/Header';
import PrimaryButton from '../components/PrimaryButton';
import IQOSImage from '../assets/image.png';
import IQOSImage2 from '../assets/image@2x.png';
import IQOSImage3 from '../assets/image@3x.png';
import { Trans, useTranslation } from '../hooks/useTranslation';
import { useNavigate } from 'react-router-dom';
import { DataContext3 } from '../contexts/DataContext3';
import { useFlow } from '../contexts/FlowContext';

function LandingPage3() {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const { trackEvent } = useContext(DataContext3);
  const { getBasePath } = useFlow();
  useEffect(() => {
    trackEvent({ Landing_page_visit: 1 });
  }, [trackEvent]);

  return (
    <Box
      sx={{
        displayl: 'flex',
        flexDirection: 'column',
        alignItems: 'stretch',
        justifyContent: 'space-between',
        gap: '0px',
        background: '#F6F4F0',
      }}
    >
      <Header />
      <Box
        sx={{
          flex: 1,
        //  height: 'calc( 96vh - 10px )',
          maxHeight: '750px',
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'space-between',
          alignItems: 'stretch',
          paddingBottom: '30px',
          paddingTop: '16px',
          paddingInline: '16px',
          gap: '15px',
        }}
      >
        <Box
          sx={{
            background: 'white',
            padding: '16px',
            paddingBottom: '16px',
            borderRadius: '4px',
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'stretch',
            justifyContent: 'space-between',
            gap: '12px',
          }}
        >
          <div
            style={{
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              borderRadius: '4px',
              background: 'linear-gradient(180deg, #F1F1F1 0%, #DFDFDF 100%)',
              minHeight: '260px',
            }}
          >
            <img
              src={IQOSImage}
              srcSet={`
       ${IQOSImage} 1x,
       ${IQOSImage2} 2x,
       ${IQOSImage3} 3x
     `}
              alt="IQOSImage"
              style={{
                maxHeight: '268px',
                width: '100%',
                objectFit: 'contain',
                borderRadius: '4px',
              }}
            />
          </div>
          <div
            style={{
              display: 'flex',
              flexDirection: 'column',
              justifyContent: 'space-between',
              gap: '12px',
            }}
          >
            <Typography
              sx={{
                fontSize: '20px',
                fontWeight: '700',
                lineHeight: '26px',
                textAlign: 'left',
                overflowY: 'hidden',
              }}
            >
              {t('landingPage.title')}
            </Typography>
            <Typography
              sx={{
                fontSize: '11px',
                fontWeight: '500',
                lineHeight: '15.4px',
                textAlign: 'left',
                overflowY: 'hidden',
              }}
            >
              
              <Trans
               
              i18nKey="landingPage.subtitle"
              t={t}
              components={
                {
  br: <br />,                }
              }
            />
            </Typography>
          </div>
        </Box>
        <Box
          sx={{
            display: 'flex',
            alignItems: 'stretch',
            flexDirection: 'column',
            gap: '14px',
          }}
        >
          <Typography
            sx={{
              fontSize: '16px',
              fontWeight: '700',
              textAlign: 'left',
            }}
          >
            {t('landingPage.benefits')}
          </Typography>
          <div
            style={{
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'stretch',
              gap: '12px',
            }}
          >
            {[1, 2, 3, 4].map((x) => (
              <div
                style={{
                  display: 'flex',
                  flexDirection: 'row',
                  alignItems: 'center',
                  gap: '10px',
                  minHeight: '22px',
                }}
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="21"
                  height="22"
                  viewBox="0 0 21 22"
                  fill="none"
                >
                  <path
                    fill-rule="evenodd"
                    clip-rule="evenodd"
                    d="M0 11.2C0 5.45447 4.65443 0.800049 10.4 0.800049C16.1456 0.800049 20.8 5.45447 20.8 11.2C20.8 16.9456 16.1456 21.6 10.4 21.6C4.65443 21.6 0 16.9456 0 11.2ZM5.35336 11.0465L9.58156 15.2577L16.2137 8.64257L15.0032 7.43208L9.58156 12.8537L6.56385 9.83601L5.35336 11.0465Z"
                    fill="#48C983"
                  />
                </svg>
                <Typography
                  sx={{
                    fontSize: '14px',
                    fontWeight: '400',
                    textAlign: 'left',
                    whiteSpace: 'nowrap',
                    lineHeight: '18.72px',
                  }}
                >
                  {t('landingPage.benefits.' + x)}
                </Typography>
              </div>
            ))}
          </div>
        </Box>
        <div style={{ paddingInline: '8px' }}>
          {' '}
          <PrimaryButton
            style={{}}
            onClick={() => {
              navigate(`${getBasePath()}/registration`);
            }}
          >
            {t('getStarted')}
          </PrimaryButton>
        </div>
      </Box>
    </Box>
  );
}

export default LandingPage3;
